module.exports = __webpack_public_path__ + "img/planta_02.3f6c497e.png";